angular.module('ResourceGenerator', [
    'ngResource',
    'ngLodash'
]);